<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户分组统计分布(一个用户可能会有多个组，会重复计算)</span>
      </div>

      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <!--        <el-form-item label="结束日期" prop="endDate">-->
        <!--          <el-date-picker-->
        <!--            v-model="queryParams.endDate"-->
        <!--            type="date"-->
        <!--            placeholder="选择日期"-->
        <!--            value-format="yyyy-MM-dd"-->
        <!--            @keyup.enter.native="handleQuery"-->
        <!--          />-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          width="120px"
          align="center"
        />

        <el-table-column
          prop="group_id"
          label="分组"
          align="center"
        >
          <template v-slot:default="scope">
            {{ groupMap[scope.row.groupId] }}
          </template>
        </el-table-column>

        <el-table-column
          prop="user"
          label="登录人数"
          width="120px"
          align="center"
        />

        <el-table-column
          prop="online_avg"
          label="人均时长(分)"
          width="120px"
          align="center"
        />

        <el-table-column
          prop="pay_rate"
          label="付费率"
          align="center"
        >
          <template v-slot:default="scope">
            {{ scope.row.pay_rate }}%
          </template>
        </el-table-column>

        <el-table-column
          prop="user_remain"
          label="活跃留存"
          align="center"
        > <template v-slot:default="scope">
          {{ scope.row.user_remain }}%
        </template>
        </el-table-column>

        <el-table-column
          prop="grant_spins"
          label="体力发放"
          align="center"
        >
          <template v-slot:default="scope">
            <el-button type="text" @click="showDialogVisible('+',scope.row.groupId)">{{ scientificFormat(scope.row.grant_spins) }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="grant_spins_avg"
          label="人均体力发放"
          align="center"
        />
        <el-table-column
          prop="cost_spins"
          label="体力消耗"
          align="center"
        > <template v-slot:default="scope">
          <el-button type="text" @click="showDialogVisible('-',scope.row.groupId)">{{ scientificFormat(scope.row.cost_spins) }}</el-button>
        </template>
        </el-table-column>
        <el-table-column
          prop="cost_spins_avg"
          label="人均体力消耗"
          align="center"
        />

        <el-table-column
          prop="slot_avg"
          label="人均转动次数"
          align="center"
        />

        <el-table-column
          prop="bet_avg"
          label="人均下注"
          align="center"
        />

        <el-table-column
          prop="net_disbursements"
          label="净消耗"
          align="center"
        />

      </el-table>

      <UserGroupStat ref="stat" class="mtop" :show-header="false" />
    </el-card>

    <el-dialog
      title="详细分布"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-table
        :data="rewardTableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="rid"
          label="类型"
          align="center"
        />
        <el-table-column
          prop="num"
          label="数量"
          align="center"
        >
          <template v-slot:default="scope">{{ scientificFormat(scope.row.num) }}</template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="占比"
          align="center"
        >
          <template v-slot:default="scope">  {{ scope.row.rate }}%</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserGroupDataStat, getUserGroupRewardData } from '@/api/statistics/user_remain'
import { getLastDates, scientificFormat } from '@/utils'
import UserGroupStat from '@/views/config/user-spins/comments/user-group-data-chart.vue'

export default {
  name: 'UserGroupDataStat',
  components: {
    UserGroupStat
  },
  data() {
    return {
      crease: '+',
      rewardTableData: [],
      dialogVisible: false,
      groupMap: [],
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 0
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }
    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables()
    },
    getTables() {
      this.queryParams.lang = ''
      getUserGroupDataStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.data
          this.groupMap = res.data.group
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.queryParams.lang = '1'
      getUserGroupDataStat(this.queryParams).then(res => {
        if (res.code === 200) {
          if (res.data.path) {
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          }

          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    },
    showDialogVisible(crease, groupId) {
      this.dialogVisible = true
      this.openDialog(crease, groupId)
    },
    openDialog(crease, groupId) {
      this.rewardTableData = []
      getUserGroupRewardData({ startDate: this.queryParams.startDate, lang: crease, id: groupId }).then(res => {
        const { data, sum, ridType } = res.data
        const tableData = []
        for (const i in data) {
          const val = data[i]
          tableData.push({
            num: val.num,
            rate: (val.num / sum * 100).toFixed(2),
            rid: ridType[val.rid]
          })
        }
        this.rewardTableData = tableData
      })
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 10px
}
</style>
